var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('QuestionBody',{attrs:{"qsNumber":_vm.qsNumber,"navigateType":_vm.navigateType,"content":_vm.content}})}
var staticRenderFns = []

export { render, staticRenderFns }